<template>
  <v-row>
    <v-col>
      <app-title>Setup Commissions</app-title>
      <v-expansion-panels popout="">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Edit Runs
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <edit-runs ref="editRuns"></edit-runs>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Edit Dealer Types
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <dealer-types ref="dealerTypes"></dealer-types>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Edit Rate Plans
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <rate-plans ref="dealerTypes"></rate-plans>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            Edit Rules
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <edit-rules ref="editRules"></edit-rules>
          </v-expansion-panel-content>
        </v-expansion-panel>


        <v-expansion-panel>
          <v-expansion-panel-header>
            Upload Suppliers File
          </v-expansion-panel-header>
          <v-expansion-panel-content>

                <v-form enctype="multipart/form-data">

                  <v-row>

                    <v-col cols="12" sm="12" md="10">
                      <v-file-input type="file" accept=".txt" label="File input" v-model="files" ref="files"></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-btn color="primary" @click="uploadFile">Upload</v-btn>
                    </v-col>

                  </v-row>

                </v-form>

          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import editRuns from "@/components/commissions/editRuns";
import dealerTypes from "@/components/commissions/dealerTypes";
import ratePlans from "@/components/commissions/ratePlans";
import editRules from "@/components/commissions/editRules";

import { createNamespacedHelpers } from "vuex";
const { mapActions: mapCommissionsActions } = createNamespacedHelpers(
	`commissions`
);

export default {
	name: "SetupCommissions",
	components: {
		"edit-runs": editRuns,
		"dealer-types": dealerTypes,
		"rate-plans": ratePlans,
		"edit-rules": editRules
	},
	data () {
		return {
			run: {},
			files: []
		};
	},
	methods: {
		...mapCommissionsActions([
			"uploadSupplierFile"
		]),
		chooseRun (value) {
			this.run = value;
		},
		listRuns () {
			this.$refs.editRuns.getRuns();
		},
		uploadFile () {

			let vm = this;
			let formData = new FormData();

			formData.append("file", vm.$refs.files.value);

			this.uploadSupplierFile(formData).then(() => {
				location.reload();
			});

		}
	}
};
</script>

<style scoped></style>
